import { Box } from '@mui/material';

import { FHSimpleTable } from '../../../../../../components/base';
import { legacyGoalsColumns, legacyGoalsTableOptions } from '../../../constants';

import type { IGoalsPracticed } from '../../../../../../utils/types';

interface LegacyGoalsPracticedListProps {
  data: IGoalsPracticed[];
}

function LegacyGoalsPracticedList(props: LegacyGoalsPracticedListProps) {
  const { data: formData = [] } = props;
  const data = formData ? formData : Object.entries(formData);

  return (
    <Box>
      <FHSimpleTable
        data={data}
        columnDefinitions={legacyGoalsColumns}
        columnOptions={legacyGoalsTableOptions}
      />
    </Box>
  );
}

export default LegacyGoalsPracticedList;
